// Web stub — RevenueCat SDK is native-only; no-op on web.
export function useRevenueCatAuth() {}
